import { render, staticRenderFns } from "./Aloader.vue?vue&type=template&id=1338d441"
import script from "./Aloader.vue?vue&type=script&lang=js"
export * from "./Aloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports